import styles from "./styles.module.scss"
import MedicineItem from "./widget";

export default MedicineItem;
export {styles};